import { Observable } from "rxjs";
import { normalize, schema } from "normalizr";
import * as actionTypes from "../constants/actionTypes";
import * as actions from "../actions";

export const setFilterForSearchEpic = action$ =>
  action$
    .ofType(
      actionTypes.SET_SEARCH_STRING,
      actionTypes.SET_TYPOLOGY,
      actionTypes.TOGGLE_TYPOLOGY_ON_SELECTED_LIST,
      actionTypes.SET_MARKET,
      actionTypes.TOGGLE_MARKET_ON_SELECTED_LIST,
      actionTypes.SELECT_CATEGORY,
      actionTypes.SELECT_PROPERTY,
      actionTypes.SELECT_TAG
    )
    .debounceTime(300)
    .mapTo(actions.resetPageForItems());

export const resetPageForItemsEpic = action$ =>
  action$.ofType(actionTypes.RESET_PAGE_FOR_ITEMS).mapTo(actions.searchItems());

/*
 uso debounceTime per non fare richieste multiple al server anche se con 
 switchMap vengono cancellate e ricevo solo il risultato dell'ultima
*/
export const fetchItemsEpic = (action$, store) =>
  action$.ofType(actionTypes.SEARCH_ITEMS).switchMap(action => {
    /*
        http://case.dev.interconnessioni.it/api/item/list
        parameters:
        
          page
          pageSize
          searchString
          market
          categories
          tags
          types
          sortBy (name/date)
      */
    const state = store.getState();
    const { items } = state;
    // setto parametri di ricerca
    const { filters } = state;
    const {
      searchString,
      types,
      categories,
      properties,
      market,
      tags
    } = setFiltersForSearch(filters);

    return Observable.ajax({
      crossDomain: true,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      url: `http://case.dev.interconnessioni.it/api/item/list`,
      body: {
        page: items.page,
        pageSize: items.itemsPerPage,
        searchString: searchString,
        market: market,
        categories: categories,
        properties: properties,
        types: types,
        tags: tags,
        sortBy: "date"
      }
    })
      .map(response => {
        console.log("items response ", response.response.results);
        const entities = normalizeItems(response.response.results.items);
        const { page, total, filters } = response.response.results;
        return actions.searchItemsSuccess({ entities, page, total, filters });
      })
      .catch(error => Observable.of(actions.searchItemsError(error.message)));
  });

const setFiltersForSearch = filters => {
  // categorie
  const { entities } = filters.byTypology.categories;
  const { selectedById } = filters.byTypology.categories;
  const selectedCategoriesValues = entities.all.map(id => selectedById[id]);
  const categories = [].concat(...selectedCategoriesValues);
  // properties
  const { entities: entitiesProperties } = filters.byTypology.properties;
  const {
    selectedById: propertiesSelectedById
  } = filters.byTypology.properties;
  const selectedPropertiesValues = entitiesProperties.all.map(
    id => propertiesSelectedById[id]
  );
  const properties = [].concat(...selectedPropertiesValues);
  // typologies
  const { typologies } = filters.mainFilters;
  const types = typologies.selectedTypologies;

  const searchString = filters.mainFilters.searchString.text;
  const market = filters.mainFilters.markets.selectedMarkets;
  const tags = filters.byTypology.tags.selectedTags;

  const _filters = {
    searchString,
    types,
    categories,
    properties,
    market,
    tags
  };
  console.log("selectedFilters ", _filters);
  return _filters;
};

const normalizeItems = items => {
  const item = new schema.Entity("items", {}, { idAttribute: "id" });
  const mySchema = [item];

  const normalizedData = normalize(items, mySchema);
  const { result, entities } = normalizedData;
  return {
    all: result,
    byId: entities.items
  };
};

export const fetchNextPageEpic = action$ =>
  action$
    .ofType(actionTypes.GET_NEXT_PAGE_FOR_ITEMS)
    .mapTo(actions.searchItems());

export const fetchItemByIdEpic = (action$, store) =>
  action$.ofType(actionTypes.GET_ITEM_BY_ID).switchMap(action => {
    const { itemID } = action.payload;
    return Observable.ajax({
      crossDomain: true,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      url: `http://case.dev.interconnessioni.it/api/item/list`,
      body: {
        page: 0,
        pageSize: 1,
        itemid: itemID
      }
    })
      .map(({ response }) => {
        // gestisco il caso non ci sia item
        if (response.results.items.length < 1)
          return actions.getItemByIdError(`no item for ID ${itemID}`);

        return actions.getItemByIdSuccess(response.results.items[0]);
      })
      .catch(error => Observable.of(actions.getItemByIdError(error.message)));
  });

export const removeItemByIdEpic = (action$, store) =>
  action$.ofType(actionTypes.UNPUBLISH_ITEM).switchMap(action => {
    const { itemID } = action.payload;
    return Observable.ajax({
      crossDomain: true,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      url: `http://case.dev.interconnessioni.it/api/item/list`,
      body: {
        page: 0,
        pageSize: 1,
        itemid: itemID
      }
    })
      .map(({ response }) => {
        return actions.unpublishItemSuccess(response.results.items[0]);
      })
      .catch(error => Observable.of(actions.unpublishItemError(error.message)));
  });

export const removeTagFromItemEpic = (action$, store) =>
  action$.ofType(actionTypes.REMOVE_TAG_FROM_ITEM).switchMap(action => {
    const { tagID, itemID } = action.payload;
    return Observable.ajax({
      crossDomain: true,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      url: `http://case.dev.interconnessioni.it/api/item/list`,
      body: {
        page: 0,
        pageSize: 1,
        itemid: itemID
      }
    })
      .map(({ response }) => {
        return actions.removeTagFromItemSuccess(tagID, itemID);
      })
      .catch(error =>
        Observable.of(actions.removeTagFromItemError(error.message))
      );
  });



// WEBPACK FOOTER //
// ./src/epics/items.js